'use client';

import { Form, Gutter, SelectInput, useConfig, useLocale, useTranslation } from '@payloadcms/ui';
import { getRouteResolver } from '@websolutespa/payload-utils';
import React, { useEffect, useMemo, useState } from 'react';
import { LlmApp } from '../../api/types';
import './Llm.scss';
import { LlmTestApp } from './LlmTestApp';

export const LlmTestClient_ = () => {

  const { t } = useTranslation<any, any>();
  const { config } = useConfig();
  const routeResolver = getRouteResolver(config);
  const locale = useLocale();
  const [apps, setApps] = useState<LlmApp[]>([]);
  const [app, setApp] = useState<LlmApp>();

  // fetch apps
  useEffect(() => {
    const fetchApps = () => {
      const url = routeResolver.api(`/llmApp?pagination=false&locale=${locale}`);
      fetch(url)
        .then(response => response.json())
        .then(apps => setApps(apps));
    };
    fetchApps();
  }, [locale]);

  const selectOptions = useMemo(() => {
    return apps.map(x => ({
      label: x.name,
      value: x.id,
    }));
  }, [apps]);

  const onSelectDidChange = (value: string) => {
    const app = apps.find(x => x.id === value);
    setApp(app);
    // console.log('onSelectDidChange', app);
  };

  return (
    <Gutter className="llm__container">
      <div className="llm__app">
        <Form className="llm__form">
          <SelectInput
            label={t('general:selectApp')}
            name="select"
            path="select"
            options={selectOptions}
            onChange={(option) => Array.isArray(option) ?
              null :
              onSelectDidChange(option.value as string)
            }
          />
        </Form>
      </div>
      {app && (
        <LlmTestApp app={app} />
      )}
    </Gutter>
  );
};

export const LlmTestClient = React.memo(LlmTestClient_);
